import { Link } from "react-router-dom";

const NotFound = () => {
    return (
        <main>
            <div className="container">
                <div className="row center">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <h2 className="title" style={{ fontSize: '100px', marginBottom: '20px' }}>
                            404
                        </h2>
                        <p style={{ textAlign: 'center', width: '100%', marginBottom: '40px' }}>
                            Oops! The page you are looking for doesn't exist.
                        </p>
                        <Link to="/" style={{ color: '#000', textDecoration: 'underline', fontWeight: 'bold' }}>
                            Return Home
                        </Link>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default NotFound;
